// extracted by mini-css-extract-plugin
module.exports = {"container":"booking_container___1agZ","dxColumn":"booking_dxColumn__QFVpP","topBar":"booking_topBar__EWGOF","backButton":"booking_backButton__ImAu_","title":"booking_title__UTSQO"};